import handOverWatch from './handOverWatch.svg';
import takeOverWatch from './takeOverWatch.svg';
import watchHandover from './watchHandover.svg';

export default {
  handOverWatch,
  takeOverWatch,
  watchHandover,
};
